// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2kEav","image":"styles_image__2OHWT","text":"styles_text__3FUL7"};